import {
  Component,
  OnInit,
  Input,
  ElementRef,
  Output,
  ContentChild,
  TemplateRef,
  EventEmitter, HostBinding
} from '@angular/core';

import * as moment from 'moment';
import { Moment } from 'moment';
import 'moment/locale/zh-cn';
export interface MonthInterface {
  index: number;
  name: string;
  isCurrentMonth: boolean;
  isSelectedMonth: boolean;
}

// export type QuartersType = Array<MonthInterface>;

export interface DayInterface {
  number: number;
  isLastMonth: boolean;
  isNextMonth: boolean;
  isCurrentDay: boolean;
  isSelectedDay: boolean;
  distanceStartDay: number;
  isMiddleDay: boolean;
  title: string;
  date: Moment;
}

export interface WeekInterface {
  days: Array<DayInterface>
}
@Component({
  selector: 'ant-datepicker',
  template:`<table>
  <thead>
      <tr>
        <th *ngFor="let _min of _listOfWeekName">
          <span class="ant-fullcalendar-column-header-inner">{{_min}}</span>
        </th>
      </tr>
    </thead>
  <tbody class="ant-fullcalendar-month-panel-tbody">
    <tr *ngFor="let week of _weeksCalendar">
      <td *ngFor="let day of week.days" 
          [class.ant-calendar-cell]="nzDatePicker"
          [class.ant-fullcalendar-last-month-cell]="day.isLastMonth" 
          [class.ant-fullcalendar-next-month-btn-day]="day.isNextMonth"
          [class.ant-fullcalendar-selected-day]="day.isSelectedDay" 
          [class.ant-fullcalendar-middle-day]="day.isMiddleDay && !day.isLastMonth && !day.isNextMonth"
          [class.ant-fullcalendar-today]="day.isCurrentDay">
        <div class="ant-fullcalendar-date" [hidden]="day.isLastMonth || day.isNextMonth">
            <div class="ant-fullcalendar-value" 
                  (click)="_clickDay($event,day)" 
                  (mouseover)="_mouseDay($event,day)">
              {{day.number}}
            </div>
        </div>
      </td>
    </tr>
  </tbody>
  </table>
`,
  styles: [`.ant-fullcalendar {
  font-size: 12px;
  line-height: 1.5;
  outline: none;
  border-top: 1px solid #d9d9d9;
}
.ant-fullcalendar-month-select {
  margin-left: 5px;
}
.ant-fullcalendar-header {
  padding: 11px 16px 11px 0;
  text-align: right;
}
.ant-fullcalendar-header .ant-select-dropdown {
  text-align: left;
}
.ant-fullcalendar-header .ant-radio-group {
  margin-left: 8px;
  text-align: left;
}
.ant-fullcalendar-header label.ant-radio-button {
  height: 22px;
  line-height: 20px;
  padding: 0 10px;
}
.ant-fullcalendar-date-panel {
  position: relative;
  outline: none;
}
.ant-fullcalendar-calendar-body {
  padding: 8px 8px 14px;
}
.ant-fullcalendar table {
  border-collapse: collapse;
  max-width: 100%;
  background-color: transparent;
  width: 100%;
  height: 246px;
}
.ant-fullcalendar table,
.ant-fullcalendar th,
.ant-fullcalendar td {
  border: 0;
}
.ant-fullcalendar td {
  position: relative;
}
.ant-fullcalendar-calendar-table {
  border-spacing: 0;
  margin-bottom: 0;
}
.ant-fullcalendar-column-header {
  line-height: 18px;
  padding: 0;
  width: 33px;
  text-align: center;
}
.ant-fullcalendar-column-header .ant-fullcalendar-column-header-inner {
  display: block;
  font-weight: normal;
}
.ant-fullcalendar-week-number-header .ant-fullcalendar-column-header-inner {
  display: none;
}
.ant-fullcalendar-month,
.ant-fullcalendar-date {
  text-align: center;
  transition: all .3s;
}
.ant-fullcalendar-value {
  display: block;
  margin: 0 auto;
  color: rgba(0, 0, 0, 0.65);
  border-radius: 4px;
  width: 22px;
  height: 22px;
  padding: 0;
  background: transparent;
  line-height: 22px;
  transition: all .3s;
}
.ant-fullcalendar-value:hover {
  cursor: pointer;
}
.ant-fullcalendar-value:active {
  background: #108ee9;
  color: #fff;
}
.ant-fullcalendar-month-panel-cell .ant-fullcalendar-value {
  width: 48px;
}
.ant-fullcalendar-today .ant-fullcalendar-value,
.ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {
  box-shadow: 0 0 0 1px #108ee9;
}
.ant-fullcalendar-selected-day .ant-fullcalendar-value,
.ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {
  background: #108ee9;
  color: #fff;
}
.ant-fullcalendar-disabled-cell-first-of-row .ant-fullcalendar-value {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.ant-fullcalendar-disabled-cell-last-of-row .ant-fullcalendar-value {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.ant-fullcalendar-last-month-cell .ant-fullcalendar-value,
.ant-fullcalendar-next-month-btn-day .ant-fullcalendar-value {
  color: rgba(0, 0, 0, 0.25);
}
.ant-fullcalendar-month-panel-table {
  table-layout: fixed;
  width: 100%;
  border-collapse: separate;
}
.ant-fullcalendar-content {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: -9px;
}
.ant-fullcalendar-fullscreen {
  border-top: 0;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-table {
  table-layout: fixed;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-header .ant-radio-group {
  margin-left: 16px;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-header label.ant-radio-button {
  height: 28px;
  line-height: 26px;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-month,
.ant-fullcalendar-fullscreen .ant-fullcalendar-date {
  text-align: left;
  margin: 0 4px;
  display: block;
  color: rgba(0, 0, 0, 0.65);
  height: 116px;
  padding: 4px 8px;
  border-top: 2px solid #e9e9e9;
  transition: background .3s;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-month:hover,
.ant-fullcalendar-fullscreen .ant-fullcalendar-date:hover {
  background: #ecf6fd;
  cursor: pointer;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-month:active,
.ant-fullcalendar-fullscreen .ant-fullcalendar-date:active {
  background: #d2eafb;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-column-header {
  text-align: right;
  padding-right: 12px;
  padding-bottom: 5px;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-value {
  text-align: right;
  background: transparent;
  width: auto;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-value {
  color: rgba(0, 0, 0, 0.65);
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-month,
.ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-date {
  border-top-color: #108ee9;
  background: transparent;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value,
.ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-value {
  box-shadow: none;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month,
.ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-date {
  background: #ecf6fd;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value,
.ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-value {
  color: #108ee9;
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-last-month-cell .ant-fullcalendar-date,
.ant-fullcalendar-fullscreen .ant-fullcalendar-next-month-btn-day .ant-fullcalendar-date {
  color: rgba(0, 0, 0, 0.25);
}
.ant-fullcalendar-fullscreen .ant-fullcalendar-content {
  height: 90px;
  overflow-y: auto;
  position: static;
  width: auto;
  left: auto;
  bottom: auto;
}
.ant-fullcalendar-disabled-cell .ant-fullcalendar-date,
.ant-fullcalendar-disabled-cell .ant-fullcalendar-date:hover {
  cursor: not-allowed;
}
.ant-fullcalendar-disabled-cell:not(.ant-fullcalendar-today) .ant-fullcalendar-date,
.ant-fullcalendar-disabled-cell:not(.ant-fullcalendar-today) .ant-fullcalendar-date:hover {
  background: transparent;
}
.ant-fullcalendar-disabled-cell .ant-fullcalendar-value {
  color: rgba(0, 0, 0, 0.25);
  border-radius: 0;
  width: auto;
  cursor: not-allowed;
}
nz-calendar {
  display: block;
  position: relative;
}
.ant-patch-full-height {
  height: 100%;
}
table {
  display: inline-block;
}
.ant-fullcalendar-middle-day {
  background: #9cdbf7;
  border-radius: 4px;
}
`]
})
export class DatepickerComponent implements OnInit {
  _el: HTMLElement;
  _weeksCalendar: Array<WeekInterface> = [];
  // _quartersCalendar: Array<QuartersType> = [];
  _listOfWeekName: Array<string> = [];
  _listOfMonthName: Array<string> = [];
  _listOfYearName: Array<string> = [];
  _yearUnit = '年';
  _monthUnit = '月';
  _showMonth = moment(new Date()).month();
  _showYear = moment(new Date()).year();
  _nowMonth = moment(new Date()).month();
  _value: Date = new Date();
  _locale = 'zh-cn';
  @Input()
  get nzValue(): Date {
    return this._value || new Date();
  }

  set nzValue(value: Date) {
    if (this._value === value) {
      return;
    }
    this._value = value || new Date();
    this._showMonth = moment(this._value).month();
    this._showYear = moment(this._value).year();
    this._buildCalendar();
  }
  @Input() nzClearTime = true;
  @Input()
  get nzShowYear() {
    return this._showYear;
  }

  set nzShowYear(value) {
    this._showYear = value;
    this._buildCalendar();
  }

  @Input()
  get nzShowMonth() {
    return this._showMonth;
  }

  set nzShowMonth(value) {
    this._showMonth = value;
    this._buildCalendar();
  }
  @Output() nzClickDay: EventEmitter<any> = new EventEmitter();
  @Output() nzMouseDay: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit() {
    this._buildCalendar();
  }
  _buildCalendar() {
    this._weeksCalendar = [];
    moment.locale(this._locale);
    this._listOfYearName = this._generateYears(this._showYear);
    this._listOfWeekName = moment.weekdaysMin();
    this._listOfMonthName = moment.months();
    const date = moment(this.nzValue).year(this._showYear).month(this._showMonth);
    this._weeksCalendar = this._buildMonth(date);
    // this._quartersCalendar = this._buildYears(date);
  };
  _generateYears(year) {
    const listOfYears = [];
    for (const i of Array.from(Array(20).keys())) {
      listOfYears.push(i - 10 + year);
    }
    return listOfYears;
  };
  _buildMonth(d: Moment): Array<WeekInterface> {
    const weeks: Array<WeekInterface> = [];
    const _rawDate = this._removeTime(d);
    const start = _rawDate.clone().date(1).day(0);
    const month = _rawDate.clone();
    let done = false;
    const date = start.clone();
    let monthIndex = date.month();
    let count = 0;
    while (!done) {
      weeks.push({ days: this._buildWeek(date.clone(), month) });
      date.add(1, 'w');
      done = count++ > 4;
      monthIndex = date.month();
    }
    return weeks;
  };
  // _buildYears(date: Moment) {
  //   const quarters = [];
  //   let months: Array<MonthInterface> = [];
  //   for (let i = 0; i < 12; i++) {
  //     months.push({
  //       index          : i,
  //       name           : this._listOfMonthName[ i ],
  //       isCurrentMonth : moment(new Date()).month() === i && date.isSame(new Date(), 'year'),
  //       isSelectedMonth: this._showMonth === i
  //     });
  //     if ((i + 1) % 3 === 0) {
  //       quarters.push(months);
  //       months = [];
  //     }
  //   }
  //   return quarters;
  // };
  _removeTime(date) {
    if (this.nzClearTime) {
      return date.hour(0).minute(0).second(0).millisecond(0);
    } else {
      return date;
    }
  };
  _buildWeek(date: Moment, month: Moment): Array<DayInterface> {
    const days: Array<DayInterface> = [];
    for (let i = 0; i < 7; i++) {
      days.push({
        number       : date.date(),
        isLastMonth  : date.month() < month.month(),
        isNextMonth  : date.month() > month.month(),
        isCurrentDay : date.isSame(new Date(), 'day') && date.month() === this._nowMonth,
        isSelectedDay: false,
        isMiddleDay  : false,
        distanceStartDay: null,
        title        : date.format('YYYY-MM-DD'),
        date         : date
      });
      date = date.clone();
      date.add(1, 'd');
    }
    return days;
  };
  _clickDay($event, day) {
    $event.preventDefault();
    $event.stopPropagation();
    this.nzClickDay.emit({day});
  };
  _mouseDay($event, day) {
    $event.preventDefault();
    $event.stopPropagation();
    this.nzMouseDay.emit({day});
  };
}
